import style from '../CreditOnboardingEgyptLuckyV1/CreditOnboardingEgyptLuckyV1.css';
import TextField from '../../shared/TextField/TextField';
import Button from '../../shared/Button/Button';
import useTranslation from '../../../localization/i18n.context';
import Title from '../../shared/Typography/Title';
import SelectBox from '../../shared/SelectBox/SelectBox';
import { useState, useEffect } from 'preact/hooks';

const StepField = {
  MARITAL_STATUS: 'maritalStatus',
  FAMILY_DEPENDENTS_COUNT: 'familyDependentsCount',
};

export default function FamilyDetailsStep({
  onInputChange,
  onButtonClick,
  data = {},
  maritalStatuses = [],
  familyMembers = [],
  stepNumber,
  stepCount,
}) {
  const { t } = useTranslation();
  const [selectedMaritalStatus, setSelectedMaritalStatus] = useState('');
  const [selectedFamilyMembers, setSelectedFamilyMembers] = useState('');
  const isButtonEnabled = Object.values(StepField).every(
    field => data[field] && data[field].value && data[field].value?.trim(),
  );

  useEffect(() => {
    updateSelectedValues(data);
  }, [data, maritalStatuses, familyMembers]);

  function updateSelectedValues(formData) {
    if (formData[StepField.MARITAL_STATUS]) {
      const status = maritalStatuses.find(
        s => s.id == formData[StepField.MARITAL_STATUS]?.value,
      );
      setSelectedMaritalStatus(status?.name ?? '');

      if (formData[StepField.FAMILY_DEPENDENTS_COUNT]) {
        const members = familyMembers.find(
          d => d.id == formData[StepField.FAMILY_DEPENDENTS_COUNT]?.value,
        );
        setSelectedFamilyMembers(members?.name);
      }
    }
  }

  const handleMaritalStatusChange = maritalStatus => {
    const status = maritalStatuses.find(s => s.name == maritalStatus);
    onInputChange({
      target: { name: StepField.MARITAL_STATUS, value: status?.id },
    });

    onInputChange({
      target: {
        name: StepField.FAMILY_DEPENDENTS_COUNT,
        value: '',
      },
    });
    setSelectedMaritalStatus(maritalStatus);
  };

  const handleFamilyDependentsChange = dependents => {
    const members = familyMembers.find(d => d.name == dependents);
    onInputChange({
      target: {
        name: StepField.FAMILY_DEPENDENTS_COUNT,
        value: members.id ?? '',
      },
    });
    setSelectedFamilyMembers(dependents);
  };

  return (
    <main className={style.main}>
      <div className={style['form-content']}>
        <div className={style['form-header']}>
          <p className={style['form-header-title']}>
            {t(`STEP {step_number}/{step_count}`, {
              '{step_number}': stepNumber,
              '{step_count}': stepCount,
            })}
          </p>
        </div>
        <div className={style['form-title']}>
          <Title text={t('What are your family details?')} />
        </div>
        <div className={style['form-inputs']}>
          <div className={style['form-control']}>
            <SelectBox
              label={t('Marital status')}
              title={t('Marital status')}
              placeholder={t('Select')}
              name={StepField.MARITAL_STATUS}
              closeOnChange={true}
              onChange={value => {
                handleMaritalStatusChange(value);
              }}
              options={maritalStatuses.map(item => item.name)}
              value={selectedMaritalStatus}
            />
          </div>
          <div className={style['form-control']}>
            <SelectBox
              label={t('Number of dependents in the family')}
              title={t('Number of dependents in the family')}
              placeholder={t('Select')}
              name={StepField.FAMILY_DEPENDENTS_COUNT}
              closeOnChange={true}
              onChange={value => {
                handleFamilyDependentsChange(value);
              }}
              disabled={selectedMaritalStatus == ''}
              options={familyMembers.map(item => item.name)}
              value={selectedFamilyMembers}
            />
          </div>
        </div>
      </div>
      <div className="fixed-cta">
        <Button fullWidth onClick={onButtonClick} disabled={!isButtonEnabled}>
          {t('Continue')}
        </Button>
      </div>
    </main>
  );
}
FamilyDetailsStep.Type = 'FamilyDetailsStep';
FamilyDetailsStep.EventName = 'family_details';
